<div class='not-interested-container'>
  <form [formGroup]="form">

    @if (activePage !== TalentProfilePage.EMPLOYMENT_SPLASH_PAGE) {
      <div class="progress-bar">
        <mat-progress-bar mode="determinate" [value]="getCompletionPercentage()"></mat-progress-bar>
        <p class="progress-bar-description">
          {{this.getActivePageNumber()}} {{'talent-happy-path.talent-profile.progress-bar-description.of' | translate}} {{totalPages}} {{'talent-happy-path.talent-profile.progress-bar-description.sections' | translate}}
        </p>
      </div>
    }
    <!-- Page 1 content -->
    @if (activePage === TalentProfilePage.EMPLOYMENT_SPLASH_PAGE) {
      <div class="section-container">
        <div class="user-info">
          <div class="header-text">{{"talent-happy-path.quick-apply.submit-page.personal-info" | translate}}</div>
          <div class="info-display">
            <div class="subheader-text">{{"talent-happy-path.quick-apply.submit-page.name" | translate}}</div>
            <div class="subheader-text">{{talent.firstName + " " + talent.lastName}}</div>
          </div>
          <mat-divider />
          <div class="info-display">
            <div class="subheader-text">{{"talent-happy-path.quick-apply.submit-page.email-address" | translate}}</div>
            <div class="subheader-text">{{gather.talentEmail}}</div>
          </div>
          <mat-divider />
          <div class="info-display">
            <div class="subheader-text">{{"redeploy.phone" | translate}}</div>
            <div class="subheader-text">{{gather.talentPhoneNumber}}</div>
          </div>
          <mat-divider />
          <div class="info-display">
            <div class="subheader-text">{{"talent-happy-path.quick-apply.submit-page.homeLocation" | translate}}</div>
          </div>
          <app-location-picker [formGroup]="form" [talent]="talent" [required]="false"></app-location-picker>
          <mat-divider />
        </div>
      </div>
      <div class="section-container">

        <app-file-upload (uploadSuccessEvent)="resumeUploadedHandler($event)"
                         (resumeUploadingEvent)="resumeUploadingHandler($event)"
                         [talentId]="gather.talentPersonId"
                         [fileUploadUserType]="fileUploadUserType"></app-file-upload>
      </div>

      @if (showPortfolioLinks) {
        <div class="medium-margin form-option section-container">
          <div class="full-width">

            <div class="flex-container flex-dir-column full-width">
              <div class="justify-end">
                <div class="optional-label">{{"talent-happy-path.quick-apply.submit-page.optional" | translate}}</div>
              </div>

              @if (talentPortfolioURLs.length === 0) {
                <mat-form-field style="width: 100%">
                  <mat-label>{{"talent-happy-path.quick-apply.submit-page.professional-profile-placeholder" | translate}}</mat-label>
                  <mat-hint align="end" class="hint">{{"talent-happy-path.quick-apply.submit-page.professional-profile-hint" | translate}}</mat-hint>
                  <input type="url"
                         matInput
                         formControlName="portfolioUrl_0"
                         id="personUriId_0"
                         (blur)="validateAndSaveURL(newPortfolioUrl, $event)"
                         (ngModelChange)="resetResponseCodes()">

                  <mat-error>
                    @if (!newPortfolioUrl.responseCode || newPortfolioUrl.responseCode === 0) {
                      {{"talent-happy-path.quick-apply.submit-page.profile-url-invalid" | translate}}
                    } @else if (newPortfolioUrl.responseCode === 403) {
                      {{"gather.error.inaccessible" | translate}}
                    } @else if (newPortfolioUrl.responseCode === 404) {
                      {{"gather.error.not-found" | translate}}
                    } @else if (newPortfolioUrl.responseCode === 500) {
                      {{"gather.error.general" | translate}}
                    } @else {
                      {{"talent-happy-path.quick-apply.submit-page.profile-url-invalid" | translate}}
                    }
                  </mat-error>

                </mat-form-field>
              }
            </div>

            @if (talentPortfolioURLs.length != 0) {
              @for (portfolioURL of talentPortfolioURLs; track portfolioURL.personUriId) {
                <div class="item">

                  <div class="url-field">
                    <mat-form-field style="width: 100%">
                      <mat-label>{{"talent-happy-path.quick-apply.submit-page.professional-profile-placeholder" | translate}}</mat-label>
                      <mat-hint align="end" class="hint">{{"talent-happy-path.quick-apply.submit-page.professional-profile-hint" | translate}}</mat-hint>
                      <input type="url"
                             matInput
                             [formControlName]="'portfolioUrl_' + $index"
                             [id]="'personUriId_' + $index"
                             (blur)="validateAndUpdateURL(portfolioURL, $event)"
                             (ngModelChange)="resetResponseCodes()">

                      <mat-error>
                        @if (!portfolioURL.responseCode || portfolioURL.responseCode === 0) {
                          {{"talent-happy-path.quick-apply.submit-page.profile-url-invalid" | translate}}
                        } @else if (portfolioURL.responseCode === 403) {
                          {{"gather.error.inaccessible" | translate}}
                        } @else if (portfolioURL.responseCode === 404) {
                          {{"gather.error.not-found" | translate}}
                        } @else if (portfolioURL.responseCode === 500) {
                          {{"gather.error.general" | translate}}
                        } @else {
                          {{"talent-happy-path.quick-apply.submit-page.profile-url-invalid" | translate}}
                        }
                      </mat-error>

                    </mat-form-field>
                    <div class="delete-url">
                      <i class="material-icons medium bold" (click)="deletePortfolioURL(portfolioURL)">delete</i>
                    </div>
                  </div>
                  <div class="clear"></div>
                </div>
              }
            }
          </div>
        </div>
      }

      @if (errorMessage) {
        <small class="error" role="alert">{{errorMessage | translate}}</small>
      }
      <div class="button-container">
        <button class="next-button" (click)="goToEmploymentOpportunities()">{{"gather.availability.next" | translate}}</button>
      </div>
    }

    @if (activePage === TalentProfilePage.EMPLOYMENT_OPPORTUNITIES) {
      <app-employment-opportunities *ngIf="activePage === TalentProfilePage.EMPLOYMENT_OPPORTUNITIES" [fromNotAFit]="true"></app-employment-opportunities>
    } @else if (activePage === TalentProfilePage.EMPLOYMENT_PREFERENCES) {
      <app-employment-preferences [fromNotAFit]="true"></app-employment-preferences>
    } @else if (activePage === TalentProfilePage.EMPLOYMENT_SALARY) {
      <app-employment-salary [fromNotAFit]="true"></app-employment-salary>
    } @else if (activePage === TalentProfilePage.EMPLOYMENT_AUTHORIZATION) {
      <app-employment-authorization [fromNotAFit]="true"></app-employment-authorization>
    } @else if (activePage === TalentProfilePage.TALENT_EEOC) {
      <app-talent-eeoc [fromNotAFit]="true"></app-talent-eeoc>
    }
  </form>
</div>
